module.exports = __webpack_public_path__ + "8ad095635b5d55c33070e65592184f6b.pdf";